import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';

export const severeHumanRightsIncidentsMetadata = {
  displayName: msg({
    message: 'Severe human-rights incidents',
    context: 'Activity data schema name for severe human rights incidents',
  }),
  fields: {
    ...coreFields,
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Severe human rights incident spend',
        context: 'The spend on severe human rights monetary remediation',
      }),
      externalDescription: msg({
        message:
          'The amount of monetary remediation spent for severe human rights incidents.',
        context:
          'Description of the spend on severe human rights monetary remediation',
      }),
    },
    did_undertaking_play_role_in_securing_remedy: {
      displayName: msg({
        message: 'Did undertaking play role in securing remedy',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether the organization played a role in securing remedy for a severe human rights incident.',
      }),
    },
    incident_id: {
      displayName: msg({
        message: 'Incident ID',
        context: 'Unique way to identify the incident.',
      }),
      externalDescription: msg({
        message: 'Unique way to identify the incident.',
        context: 'Severe human rights incident ID',
      }),
    },
    is_case_of_non_respect: {
      displayName: msg({
        message: 'Is case of non-respect',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether the incident represents a case of non-compliance with human rights standards.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
